/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayNodeInterface
 */

'use strict';

module.exports = require('./RelayOSSNodeInterface');


//////////////////
// WEBPACK FOOTER
// ../~/react-relay/lib/RelayNodeInterface.js
// module id = 10
// module chunks = 17